import React , {Component} from 'react';
import * as axios from "axios/index";
import validator from 'validator';
import {
    Page  , Link , Actions , ActionsGroup , ActionsLabel , ActionsButton , Popup , Navbar , NavRight , Button
} from 'framework7-react';
import { connect } from "react-redux";
import Select from 'react-select';
import {
    toolbar
} from "../actions";
import Loading from "../Loader/Loading";
import AddressLoader from "../Loader/AddressLoader";
import AddressCard2 from "../Cards/AddressCard2";
import * as vars from './Vars';

class MyAddress extends Component{



    onPageBeforeIn(){
        this.props.toolbar(false)
    }


    constructor(props){
        super(props)
        this.state = {
            fields : {
                address : '' ,
                city : 'بابل' ,
                deliveryId : ""
            } ,
            errors : {} ,


            requestLoading : true ,
            userAddress : [] ,
            deliveryList : [] ,

            requestInPageLoading : false ,
            modal : {
                modalMessageShow : false ,
                modalMessageBody :  "",
                modalMessageTitle : "" ,


            },

            newAddressModal : false ,

            requestError : false

        }
    }



    handleModalClose(){
        this.setState({
            modal : {
                modalMessageShow : false ,
            }
        })
    }







    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        let errors = this.state.errors
        errors[target.name] = undefined
        this.setState({errors: errors , fields:fields})
    }

    handleSubmit(event){
        event.preventDefault()


        this.handleValidation( (valid) => {
            if (valid)
            {

                this.setState({
                    requestInPageLoading : true
                })

                let data = new FormData()
                data.append('user_app_version' , '100' )
                data.append('a_token' , 'webapp' )
                data.append('mobile' , localStorage.getItem('mobile') )
                data.append('imei_code' , localStorage.getItem('imeiCode') )
                data.append('users_ID' , localStorage.getItem('users_ID') )
                data.append('add_edit_delete' , "add" )
                data.append('branch_id' , this.props.branch.ID )
                data.append("address" , this.state.fields.address)
                data.append("delivery_ID" , this.state.fields.deliveryId)

                axios.post(vars.PreUrl + 'https://www.lavefood.com/v3/address' , data )
                    .then(response => {
                        let data = response.data.result[0]

                        if(data.error === 0)
                        {
                            let address = {

                                "ID" : data.address.ID ,
                                "address" : data.address.address ,
                                "location" : data.address.location ,
                                "price" : data.address.price ,
                            }
                            this.setState({
                                userAddress : [...this.state.userAddress , address] ,
                                requestInPageLoading : false ,
                                requestLoading : false ,
                                modal : {
                                    modalMessageShow : true ,
                                    modalMessageBody :  "آدرس شما با موفقیت اضافه شد" ,
                                    modalMessageTitle : "پیغام" ,


                                } ,
                                requestError : false
                            })


                        }
                        else
                        {
                            this.setState({
                                requestInPageLoading : false ,
                                modal : {
                                    modalMessageShow : true ,
                                    modalMessageBody :  data.error_body ,
                                    modalMessageTitle : "خطا" ,


                                },
                                requestError : true
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.setState({
                            requestInPageLoading : false ,
                            modal : {
                                modalMessageShow : true ,
                                modalMessageBody :  "مشکلی پیش آمده. لطفا مجددا تلاش کنید",
                                modalMessageTitle : "خطا" ,


                            },
                            requestError : true
                        })
                    })



            }

        })
    }


    handleValidation(callback){
        let { fields } = this.state
        let errors = {}
        let formIsValid = true
        if (validator.isEmpty(fields.address))
        {
            formIsValid = false;
            errors['address'] = 'آدرس خود را وارد کنید';
        }
        else if(! validator.isLength(fields.address , { min : 1 , max : 99999}))
        {
            formIsValid = false;
            errors['address'] = 'آدرس خود را صحیح وارد کنید';
        }

        this.setState({errors} , () => {
            return callback(formIsValid)
        })
    }

    componentDidMount(){


        if (localStorage.getItem('logged') === undefined  || localStorage.getItem('logged') === null)
        {
            this.$f7router.navigate('/login-singup/')
            return false
        }


        localStorage.removeItem('selectedDelivery' )

        let data = new FormData()
        data.append('imei_code' , localStorage.getItem('imeiCode') )
        data.append('users_ID' , localStorage.getItem('users_ID') )
        data.append('add_edit_delete' , "list" )
        axios.post(vars.PreUrl + 'https://www.lavefood.com/v3/address' , data )
            .then(response => {

                let data = response.data.result[0]
                if(data.error === 0)
                {
                    this.setState({
                        userAddress : data.user_address ,
                        deliveryList:  data.delivery_list ,
                        requestLoading : false
                    })
                }
                else
                {

                }




            })
            .catch(error => {
                console.log(error)
            })

    }


    render(){
        const {errors} = this.state
        const deliveryList = []
        const city = this.state.fields.city
        this.state.deliveryList.forEach(function (delivery) {
            if( delivery.location.startsWith(city) )
            {
                deliveryList.push({
                    label : delivery.location ,
                    value : parseInt( delivery.ID)
                })
            }
        })
        return(
            <Page name="Address" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>

                <div id="inner-header" >

                    <Link back id="back">
                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                    </Link>
                    <div className="title">
                        آدرس های من
                    </div>
                </div>

                <div id="inner-header-separator" />


                {
                    this.state.requestLoading === true ? (
                        <AddressLoader  />
                    ): (
                        <div style={{ paddingBottom:"200px" }} className="h-100 overflow-y-scroll">
                            <Loading show={this.state.requestInPageLoading} />

                            {
                                this.state.userAddress.map((object , index) =>
                                    <AddressCard2 object={object} key={index} deliveryList={this.state.deliveryList} showPrice={true} history={this.props.history}   />
                                )
                            }


                            <Button id="new-address-floating-button"  onClick={()=> this.setState({newAddressModal : true})}>+ آدرس جدید</Button>

                        </div>
                    )
                }




                <Actions className="modal-custom-1"  ref="actionsOneGroup" opened={this.state.modal.modalMessageShow} onActionsClosed={() => this.handleModalClose(false)}>
                    <ActionsGroup>
                        <ActionsLabel>{this.state.modal.modalMessageTitle}</ActionsLabel>
                        <div className="content">
                            {this.state.modal.modalMessageBody}
                        </div>
                        <div className="footer">
                            <ActionsButton>
                                <span className="footer-close" onClick={ () => this.state.requestError ? `` : this.setState({newAddressModal : false}) }>
                                    خب
                                </span>
                            </ActionsButton>
                        </div>
                    </ActionsGroup>
                </Actions>


                <Popup id="new-address-form-popup" swipeToClose opened={this.state.newAddressModal} onPopupClosed={() => this.setState({newAddressModal : false})}>
                    <Loading show={this.state.requestInPageLoading} />
                    <Page>
                        <Navbar title="افزودن آدرس">
                            <NavRight>
                                <Link popupClose>بستن</Link>
                            </NavRight>
                        </Navbar>

                        <div className="display-flex justify-content-center align-items-center h-100">

                            <form onSubmit={this.handleSubmit.bind(this)} className="input-container pt-0">


                                <label htmlFor="phone" className="label">
                                    <img src="https://www.lavefood.com/webappassets/images/edit.svg" className="img"/>
                                    <div className="title">
                                        انتخاب شهر
                                    </div>
                                </label>

                                <div className="form-group">
                                    <select name="city" className="form-control input-field-2" defaultValue={this.state.fields.city} onChange={this.handleChange.bind(this)}>
                                        <option value="بابل">بابل</option>
                                        <option value="ساری">ساری</option>
                                        <option value="قائمشهر">قائمشهر</option>
                                        <option value="بابلسر">بابلسر</option>
                                        <option value="آمل">آمل</option>
                                    </select>
                                </div>



                                <label htmlFor="phone" className="label">
                                    <img src="https://www.lavefood.com/webappassets/images/edit.svg" className="img"/>
                                    <div className="title">
                                        انتخاب محدوده
                                    </div>
                                </label>

                                <div className="form-group">
                                    <Select options={deliveryList} name="delivery_ID" onChange={opt => this.setState({fields : { ...this.state.fields , deliveryId : opt.value }})} />
                                </div>

                                <label htmlFor="phone" className="label">
                                    <img src="https://www.lavefood.com/webappassets/images/edit.svg" className="img"/>
                                    <div className="title">
                                        آدرس کامل
                                    </div>
                                </label>
                                <div className="form-group">
                                    <textarea name="address" onChange={this.handleChange.bind(this)}  className="form-control input-field" />
                                    <span className={["invalid-feedback" ,  errors['address'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['address'] }</span>
                                </div>


                                <div className="input-group">
                                    <button type="submit" className="btn btn-custom-4 ">
                                        افزودن
                                    </button>
                                </div>

                            </form>



                        </div>
                    </Page>
                </Popup>

            </Page>
        )
    }
}

const mapDispatchToProps = dispatch => ({

    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        toolbarShow : state.toolbar ,
        branch : state.branch ,
    }
}

export default connect( mapStateToProps  , mapDispatchToProps)(MyAddress);